import { render, staticRenderFns } from "./addNewProduct.vue?vue&type=template&id=51c3e535"
import script from "./addNewProduct.vue?vue&type=script&lang=js"
export * from "./addNewProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports